module.exports = __webpack_public_path__ + "static/images/yz-tag.8319e8e.png";